export default "__VITE_ASSET__CvsU0_$k__"